import axios from 'axios'
import { displayNotification } from './notificationsActions'
import {
  UPDATE_OWNERSHIP_DATA,
  UPDATE_LOAN_DATA,
  UPDATE_RESIDENCE_DATA,
  UPDATE_INCOME_DATA,
  UPDATE_CONSENT_DATA,
  SET_CURRENT_STEP,
  SET_APPLICATION_IDS,
  COMPLETE_APPLICATION,
  RESET_REFI_APPLICATION,
  clearRefiApplicationFromStorage,
} from '../reducers/refiApplication'

// Action Creators

export const updateOwnershipData = (data: any) => ({
  type: UPDATE_OWNERSHIP_DATA,
  payload: data,
})

export const updateLoanData = (data: any) => ({
  type: UPDATE_LOAN_DATA,
  payload: data,
})

export const updateResidenceData = (data: any) => ({
  type: UPDATE_RESIDENCE_DATA,
  payload: data,
})

export const updateIncomeData = (data: any) => ({
  type: UPDATE_INCOME_DATA,
  payload: data,
})

export const updateConsentData = (data: any) => ({
  type: UPDATE_CONSENT_DATA,
  payload: data,
})

export const setCurrentStep = (step: string) => ({
  type: SET_CURRENT_STEP,
  payload: step,
})

export const setApplicationIds = (ids: { productPackageId?: string | null; organizationId?: string | null }) => ({
  type: SET_APPLICATION_IDS,
  payload: ids,
})

export const completeApplication = () => ({
  type: COMPLETE_APPLICATION,
})

export const resetRefiApplication = () => ({
  type: RESET_REFI_APPLICATION,
})

export const submitRefiApplication = (payload: any) => {
  return async (dispatch: any) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BLINKER_API_URL}/api/v3/admin/refi_applications`, payload)

      // Mark application as complete
      dispatch(completeApplication())
      
      // Clear localStorage after successful submission
      clearRefiApplicationFromStorage()

      // Clear Redux state
      dispatch(resetRefiApplication())
      
      // Show success notification
      dispatch(displayNotification('Application submitted successfully!', 'success') as any)
      
      return response.data
    } catch (error: any) {
      const errorMessage = error.response?.data?.message || 'Failed to submit application'
      dispatch(displayNotification(errorMessage, 'error') as any)
      
      throw error
    }
  }
}

